<mat-dialog-content class="text-center popup">
  <h4 mat-dialog-title>Error!</h4>
  <p>{{message}}</p>
  <div class="btn-action-group">
      <button (click)="onSubmit()" [mat-dialog-close]="true">Close</button>
  </div>
</mat-dialog-content>